import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './store';

// react-redux 9 types `useDispatch` as Dispatch<UnknownAction>; cast to thunk-capable dispatch.
export function useAppDispatch() {
  return useDispatch() as unknown as AppDispatch;
}
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
